const isSubscriptionCheckout = window.location.pathname.startsWith('/subscriptions/');
const stripeJs = isSubscriptionCheckout
  ? require('@stripe/stripe-js/pure')
  : require('@stripe/stripe-js');

export const loadStripe = stripeJs.loadStripe as typeof import('@stripe/stripe-js').loadStripe;
